import { Component } from '@angular/core';
import { StorageService } from '../../services/storage-service';
import { DataService } from '../../services/data';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-authen',
  imports: [],
  templateUrl: './authen.html',
  styleUrl: './authen.scss',
})
export class Authen {
  user: boolean = false
  constructor(public data: DataService,
    public st: StorageService,
    private http: HttpClient
  ) {
    this.st.getAccessToken()

    // this.data.userProfile$.subscribe({
    //   next: (res: any) => {
    //     if (res?.accessToken) this.user = true


    //   }
    // })
    // this.http.get(`/api/Public/AuthHotel`).subscribe({
    //   next: (res: any) => {
    //     // console.log(res.data);

    //   }
    // })
    // console.log(this.data.userProfile);
  }
}
